<template>
<div>
    <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
            <img class="u-pl2 u-pb2 u-pt2" src="https://shift-manager.mobilerocket.co.uk/storage/business-logos/rocket.png"/>
        </div>
    </div>

    <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
            <h1 class="t-secondary">404: Not Found</h1>
            <p>The page you were looking for could not be found.</p>
        </div>
    </div>
</div>

</template>

<script>

export default {
    name : '404'
}
</script>